// always name your leaf after folder name
export const leaf = 'auth';
export const initialState = { }
export const noobUser = {
  id: '0',
  username: 'N/A'
}



// WEBPACK FOOTER //
// ./src/sdk/auth/const.js